import { Component, Renderer2,ElementRef, OnInit } from '@angular/core';
import {HelperService} from '../../shared/services/helper.service';
import {ApiServices} from '../../shared/services/api.service';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {Cart, CartItem} from '../../shared/interfaces/Cart.interface';
import {ToastrService} from 'ngx-toastr';
import {DataService} from '../../shared/services/data.service';
import {log} from 'util';
import {MetaService} from '../../shared/services/meta.service';

import * as $ from 'jquery';
import { Constants } from 'src/app/shared/contants';

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss']
})
export class ShoppingCartComponent implements OnInit {

  cartSubscription: Subscription;
  quantitySubscription: Subscription;
  deleteProcessing = false;
  cartData: Cart;
  isLoggedIn = false;
  is_hide_cost:any;
  ts_user_data:any;
  trans = Constants.categoryTrans;

  constructor(
    private apiService: ApiServices,
    public helperService: HelperService,
    private route: ActivatedRoute,
    private toastr: ToastrService,private metaService: MetaService,
    private dataService: DataService,
    private _renderer2: Renderer2,
    private elRef: ElementRef
  ) {
    this.is_hide_cost = localStorage.getItem("is_hide_cost");
    helperService.setPageTitle(route.snapshot.data.title);
    
    // Check login status once on initialization
    this.checkIsLoggedIn();
    
    // Subscribe to login status changes (but don't trigger checkIsLoggedIn from here)
    dataService.isLoggedIn.asObservable().subscribe(loggedin => {
      this.isLoggedIn = loggedin;
    });
  }

  ngOnInit(): void {
    this.getMyCart();
    this.metaService.updateCanonicalURL();
    const user_data_from_localstorage = localStorage.getItem("ts_user_data");
    if (user_data_from_localstorage) {
      this.ts_user_data = JSON.parse(user_data_from_localstorage)
    }
  }

  checkIsLoggedIn(): void {
    const access_token = localStorage.getItem('ts_vendor_access_token');
    if(access_token) {
      this.isLoggedIn = true;
      this.dataService.isLoggedIn.next(true);
    } else {
      this.isLoggedIn = false;
      this.dataService.isLoggedIn.next(false);
    }
  }

  getMyCart(): void {
    this.cartSubscription = this.apiService.getCart().subscribe(
      response => {
        if (response.status) {
          this.cartData = response.data;
          this.dataService.setCartData(response);
        }
      }, error => {
        console.log('error', error);
      }
    );
  }

  isSameVendor(item) {
    if (item?.product_variant?.product?.vendor_id == this.ts_user_data?.user_data?.ware_house?.vendor_id) {
      return true
    } else {
      return false;
    }
  }


  onChangeWarehouseQuantity(cart_id: number, item: any, type = 'plus'): void {
    let quantity = item.quantity;
    if (type == 'plus') {
      ++quantity;
    } else if(type == 'minus' && quantity > 1) {
      --quantity;
    } else {
      return;
    }

    this.onUpdateQuantity(cart_id, item.id, quantity);
  }

  updateQuantity(cart_id: number, item: any, event:any){
    const quantity_box = event.target as HTMLInputElement;
    const quantity = parseInt(quantity_box.value);
    if (isNaN(quantity)) {
      quantity_box.value = item.quantity;
    } else {
      this.onUpdateQuantity(cart_id, item.id, quantity);
    }
  }

  onUpdateQuantity(cart_id, cart_item_quantity_id, quantity){
    const formData = {
      id: cart_id,
      cart_item_quantity_id: cart_item_quantity_id,
      quantity:quantity,
      session_id: localStorage.getItem('session_id')
    };

    this.quantitySubscription = this.apiService.changeWareouseQuantity(formData).subscribe(
      res => {
        if(res.status) {
          this.cartData = res.data;
          this.dataService.setCartData(res);
          this.toastr.success(res.message);
        } else {
          this.toastr.error(res.message);
        }
      }, err => {
        this.toastr.error(err.error.message);
      }
    );
  }

  getTotal(price, discount, quantity){
    return ((parseFloat(price) + parseFloat(discount)) * parseFloat(quantity))
  }

  getFakeTotal(){
    let total = 0;
    this.cartData.cart_items.forEach((ci)=>{
      const price = ci.product_variant.sale_price == null ? ci.price : ci.product_variant.sale_price;
      total += price * ci.quantity;
      if (ci.custom_finish) {
        total += parseFloat(ci.custom_finish_price);
      }

      if (ci.cost_per_wheel) {
        total +=  parseFloat(ci.cost_per_wheel) * ci.quantity
      }
    })
    this.cartData.addons.forEach((ca)=>{
      total += this.getAccessoryTotal(ca.unit_price, ca.discount, ca.quantity)
    })
    return total;
  }

  getAccessoryTotal(price, discount, quantity){
    return ((parseFloat(price) + parseFloat(discount)) * parseFloat(quantity))
  }

  onDeleteItem(item: CartItem): void {
    console.log(item);
    item.loading = true;
    this.cartSubscription = this.apiService.deleteCartItem(item.id).subscribe(
      response => {
        item.loading = false;
        if(response.status) {

          let script = this._renderer2.createElement('script');
          script.type = 'text/javascript';
          script.text = `
          dataLayer.push({
            'event': 'removeFromCart',
            'ecommerce': {
              'remove': {
                'products': [
                  {
                    'id': '`+item.product_id+`',
                    'category': 'Alloy Wheel',
                    "quantity": '`+item.quantity+`',
                    'variant': '`+item.product_variant_id+`',
                    'price': '`+item.price+`'
                  }
                ]
              }
            }
          });
          `;
          $( "#googleTagManagerScript" ).before( script );



          // (<any>window).dataLayer.push({
          //   'event': 'removeFromCart',
          //   'ecommerce': {
          //     'remove': {
          //       'products': [{
          //         'id': item.product_id,
          //         'price': item.price,
          //         'quantity': item.quantity,
          //         'variant': item.product_variant_id,
          //         'category': 'Alloy Wheel'
          //       }]
          //     }
          //   }
          // });


          this.cartData = response.data;
          this.dataService.setCartData(response);
          this.toastr.success(response.message);
        } else {
          this.toastr.error(response.message);
        }
      }, error => {
        item.loading = false;
        this.toastr.error(error.error.message);
      }
    );
  }

  getTotalNum(cartData){
    return Number(cartData.sub_total) - Number(cartData.self_owned_total)
  }

  onDeleteAllItem(): void {
    this.cartSubscription = this.apiService.deleteAllCartItem().subscribe(
      response => {
        if(response.status) {
          this.cartData = null;
          this.toastr.success(response.message);
        } else {
          this.toastr.error(response.message);
        }
      }, error => {
        this.toastr.error(error.error.message);
      }
    );
  }

  addonDeleteItem(item: any): void {
    // console.log(item);
    item.loading = true;
    this.cartSubscription = this.apiService.addonsRemoveFromCart(item.id).subscribe(
      response => {
        item.loading = false;
        if(response.status) {

          // $( "#gtagId" ).remove();
          let script = this._renderer2.createElement('script');
          script.id = 'gtagId';
          script.type = 'text/javascript';
          script.text = `
          dataLayer.push({
            'event': 'removeFromCart',
            'ecommerce': {
              'remove': {
                'products': [
                  {
                    'id': '`+item.id+`',
                    'name': '`+item.title+`',
                    'category': 'Alloy Wheel',
                    "quantity": '`+item.quantity+`',
                    'price': '`+item.unit_price+`'
                  }
                ]
              }
            }
          });
          `;
          $( "#googleTagManagerScript" ).before( script );


          this.cartData = response.data;
          this.dataService.setCartData(response);
          this.toastr.success(response.message);
        } else {
          this.toastr.error(response.message);
        }
      }, error => {
        item.loading = false;
        this.toastr.error(error.error.message);
      }
    );
  }
  hasCostPerWheel(): boolean {
    return this.cartData && this.cartData.cart_items && this.cartData.cart_items.some(item => item.cost_per_wheel !== null && item.cost_per_wheel !== '');
  }
}
